// Formateadores compartidos por los widgets. El `format` declarado en la config
// elige cuál se aplica a cada métrica.

export function formatValue(value, format) {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  switch (format) {
    case 'pct':
      return `${Number(value).toFixed(2)} %`;
    case 'money':
      return `$${Number(value).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    case 'milesK': {
        // 12570 -> "12.57 mil" (replica el formato del PowerBI)
      const n = Number(value);
      if (Math.abs(n) >= 1000) return `${(n / 1000).toLocaleString('es-MX', { maximumFractionDigits: 2 })} mil`;
      return n.toLocaleString('es-MX');
    }
    case 'int':
      return Number(value).toLocaleString('es-MX');
    default:
      return String(value);
  }
}

// Color por signo del índice (en este negocio: barato = bueno = teal, caro = rojo).
export function signColor(value, theme) {
  if (value === null || value === undefined) return theme.primary;
  return Number(value) < 0 ? theme.negative : theme.positive;
}
